import React from "react";
import { CardDefundingTransactionDetailSummaryModel } from "src/models/CardDefundingTransactionDetailSummaryModel";

interface Props {
  summaryDetail: CardDefundingTransactionDetailSummaryModel;
}

const CardDefundingTransactionDetailSummaryData: React.FC<Props> = ({ summaryDetail }) => {
  if (!summaryDetail) return null;

  return (
    <div className="summary-data">
      <div className="summary-row">
        <div className="summary-label">Account Maintenance Fee Amount</div>
        <div className="summary-value">
          {summaryDetail.amountTypes?.map((a) => (
            <div key={`maint-${a.currencyAlphaCode}`}>
              {a.currencyAlphaCode}: {a.maintenanceFeeAmount?.toLocaleString?.() ?? (0).toLocaleString()}
            </div>
          ))}
        </div>
      </div>

      <div className="summary-row">
        <div className="summary-label">Account Maintenance Fee Count</div>
        <div className="summary-value">
          {summaryDetail.transactionTypeCounts?.find(t => t.description?.toLowerCase().includes("maintenance"))?.count ?? 0}
        </div>
      </div>

      <div className="summary-row">
        <div className="summary-label">Total Defunded Amount</div>
        <div className="summary-value">
          {(
            summaryDetail.amountTypes?.reduce((s, a) => s + (a.totalCardAmount ?? 0), 0) ?? 0
          ).toLocaleString()}
        </div>
      </div>

      <div className="summary-row">
        <div className="summary-label">Total Defunded Count</div>
        <div className="summary-value">
          {summaryDetail.totalTransactions ?? summaryDetail.transactionTypeCounts?.reduce((s, t) => s + t.count, 0) ?? 0}
        </div>
      </div>
    </div>
  );
};

export default CardDefundingTransactionDetailSummaryData;